import { UserRole } from 'interfaces/user.interface'
import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/app/layouts/EmptyLayout.vue'),
    meta: { middleware: ['auth'] },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('./channel/ui/ChannelsPage.vue'),
      },
    ],
  },

  // Protected: requires auth
  {
    path: '/:channelId',
    component: () => import('@/app/layouts/SidebarLayout.vue'),
    meta: { middleware: ['auth', 'channel'] },
    children: [
      {
        path: '',
        redirect: { name: 'chat' },
      },
      {
        path: 'chat',
        name: 'chat',
        component: () => import('./chat/ui/ChatPage.vue'),
      },
      {
        path: 'content-management',
        name: 'content-management',
        redirect: { name: 'content-management-list' },
        children: [
          {
            path: 'content',
            children: [
              {
                path: '',
                name: 'content-management-list',
                component: () => import('./content/ui/ContentManagementPage.vue'),
              },
              {
                path: 'create',
                name: 'content-management-form',
                component: () => import('./content/ui/ContentManagementFormPage.vue'),
              },
              {
                path: ':contentId',
                name: 'content-management-detail-form',
                component: () => import('./content/ui/ContentManagementFormPage.vue'),
              },
            ],
          },
          {
            path: 'category',
            meta: { middleware: ['auth', 'role'], roles: [UserRole.SUPER_ADMIN] },
            children: [
              {
                path: '',
                name: 'content-category-management-list',
                component: () => import('./content/category/CategoryManagementPage.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'post-management',
        children: [
          {
            path: '',
            name: 'post-management',
            component: () => import('./post/ui/PostManagementPage.vue'),
          },
          {
            path: ':postId',
            children: [
              {
                path: '',
                name: 'post-detail',
                component: () => import('./post/ui/PostDetailPage.vue'),
              },
              {
                path: 'content/create',
                name: 'post-content-form',
                component: () => import('./content/ui/ContentManagementFormPage.vue'),
              },
              {
                path: 'content/:contentId',
                name: 'post-content-detail-form',
                component: () => import('./content/ui/ContentManagementFormPage.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'agent-coordination',
        name: 'agent-coordination',
        component: () => import('./agent-coordination/ui/AgentCoordinationPage.vue'),
      },
      {
        path: 'report',
        name: 'report',
        redirect: { name: 'chat-report' },
        children: [
          {
            path: 'chat',
            name: 'chat-report',
            component: () => import('./report/ui/ChatReportPage.vue'),
          },
          {
            path: 'comment',
            name: 'comment-report',
            component: () => import('./report/ui/CommentReportPage.vue'),
          },
        ],
      },
    ],
  },

  {
    path: '/login',
    redirect: { name: 'auth-callback' },
  },

  // Guest only: redirects authenticated users to home
  {
    path: '/auth',
    component: () => import('@/app/layouts/EmptyLayout.vue'),
    meta: { middleware: ['guest'] },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('./auth/ui/LoginPage.vue'),
      },
      {
        path: 'callback',
        name: 'auth-callback',
        component: () => import('./auth/callback/AuthCallbackPage.vue'),
      },
    ],
  },

  // Public: troubleshooting
  {
    path: '/clear-session',
    component: () => import('@/app/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        name: 'clear-session',
        component: () => import('./clear-session/ui/ClearSessionPage.vue'),
      },
    ],
  },

  // Public: error pages
  {
    path: '/forbidden',
    component: () => import('@/app/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        name: 'forbidden',
        component: () => import('./forbidden/ui/ForbiddenPage.vue'),
      },
    ],
  },

  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/app/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('./not-found/ui/NotFoundPage.vue'),
      },
    ],
  },
]
